import { Ellipsis } from 'lucide-react';
import styled from 'styled-components';

import { CenterFlex, Flex } from '@/components/base';
import Menu from '@/components/Menu/Menu';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import { addProtocol } from '@/utils/util';

import type { BookmarkModalState } from './Bookmark';
import useBookmarkItem from './useBookmarkItem';

interface Props extends BookmarkT {
  setBookmarkModalStatus?: (state: BookmarkModalState) => void;
}

const BookmarkItem = ({ link, name, alias, setBookmarkModalStatus }: Props) => {
  const color = useColor();
  const image = useBookmarkItem(link);

  return (
    <Style>
      <Wrapper>
        <IconArea>
          <div className="non-hover-item">{image}</div>
          <Menu
            triggerNode={
              <Ellipsis
                className="hover-item"
                size={12}
                color={color.gray600}
                style={{ cursor: 'pointer' }}
              />
            }
            options={[
              {
                label: 'Edit',
                onClick: () => {
                  setBookmarkModalStatus?.({
                    status: true,
                    action: 'edit',
                    target: alias,
                  });
                },
              },
              {
                label: 'Delete',
                onClick: () => {
                  setBookmarkModalStatus?.({
                    status: true,
                    action: 'delete',
                    target: alias,
                  });
                },
              },
            ]}
          />
        </IconArea>
        <Typo
          type="label3"
          color={color.gray700}
          style={{ maxWidth: 200 }}
          ellipsis
          onClick={() => {
            window.open(addProtocol(link), '_blank');
          }}
        >
          {name}
        </Typo>
      </Wrapper>
    </Style>
  );
};

const Style = styled(Flex)`
  position: relative;
  align-items: center;
  background: ${(props) => props.theme.colors.gray100};
  border-radius: 4px;
  transition: all 0.2s;
  .non-hover-item {
    transition: all 0.2s;
    position: absolute;
    opacity: 1;
  }
  .hover-item {
    transition: all 0.2s;
    position: absolute;
    opacity: 0;
  }
  &:hover {
    background-color: ${(props) => props.theme.colors.ND04};
    .non-hover-item {
      opacity: 0;
    }
    .hover-item {
      opacity: 1;
    }
  }
`;

const IconArea = styled(CenterFlex)`
  width: 16px;
  height: 16px;
  position: relative;
`;

const Wrapper = styled(Flex)`
  gap: 8px;
  height: 24px;
  padding: 0 4px;

  align-items: center;
  cursor: pointer;

  .default-option-item {
    padding: 6px 8px;
  }
`;

export default BookmarkItem;
